import { render } from "./index.vue?vue&type=template&id=fffc5c4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fffc5c4c&scoped=true&lang=css"

import exportComponent from "F:\\2021年交接\\前端嘉俊交接\\项目\\新重本紫腾重构\\zbzt-website-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffc5c4c"]])

export default __exports__